﻿import React from 'react';
import Downshift from 'downshift';

import DynamicFormHelpText from '../Components/DynamicFormHelpText';
import DynamicFormError from '../Components/DynamicFormError';

import descSort from '../../Utils/descSort';

const FreetextDropdown = ({ question, value, onChange, isValid, isTouched, invalidError }) => {
    const inputValue = value || '';

    const findItemByValue = (value) => question.options.find(option => option.text === value);

    const handleSelection = (selectedItem) => {
        const newValue = selectedItem ? selectedItem.text : '';
        onChange({ target: { value: newValue } });
    };

    const currentItem = findItemByValue(inputValue) || {text: ''};

    // Filter options based on input value
    const filteredOptions = question.options.filter(option => option.text.toLowerCase().includes(value.toLowerCase()));

    return (
        <div>
            <label htmlFor={question.id}>
                {question.questionText}
                {question.helpText && <DynamicFormHelpText questionGroupHelpText={question.helpText} />}
            </label>

            <div className="dynamicFormAutocompleteWrapper">
                <Downshift
                    inputValue={inputValue}
                    onChange={handleSelection}
                    selectedItem={currentItem}
                    itemToString={item => (item ? item.text : '')}
                >
                    {({
                        getInputProps,
                        getItemProps,
                        getMenuProps,
                        highlightedIndex,
                        isOpen,
                    }) => (
                        <div>
                            <input {...getInputProps({
                                onChange: e => {
                                    onChange({ target: { value: e.target.value } });
                                }
                            })} />
                            {/* Render dropdown only if there are matching options */}
                            {isOpen && filteredOptions.length > 0 && (
                                <div {...getMenuProps()} className="dynamicFormAutocompleteMenu">
                                    {filteredOptions.sort(descSort('text')).map((item, index) => (
                                        <div
                                            {...getItemProps({
                                                key: item.text,
                                                index,
                                                item,
                                                style: {
                                                    backgroundColor: highlightedIndex === index ? 'lightgray' : 'white',
                                                    fontWeight: item.text === currentItem.text ? 'bold' : 'normal',
                                                },
                                            })}
                                            className={`dynamicFormAutocompleteMenuItem ${highlightedIndex === index ? 'dynamicFormAutocompleteMenuItem--active' : ''}`}
                                        >
                                            {item.text}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </Downshift>
            </div>

            {!isValid && typeof isValid !== 'undefined' && isTouched &&
                <DynamicFormError>
                    {invalidError}
                </DynamicFormError>
            }
        </div>
    );
};

export default FreetextDropdown;